import React, { memo, useContext } from 'react';
import { useI18n } from '../../../../i18n';

import { TAB_TYPE_SELLING } from '../../constants';
import TabsContext from '../contexts/TabsContext';
import TransactionContext from '../contexts/TransactionContext';
import S from './style/TrackingInfo';

const i18nKey = (key: string | TemplateStringsArray) => `dlv_orders_details_${key}`;

interface Props {
  hasLabelless?: boolean;
}

const TrackingInfo: React.FC<Props> = function TrackingInfo({ hasLabelless }) {
  const i18n = useI18n();
  const tabType = useContext(TabsContext);
  const transaction = useContext(TransactionContext);
  const isSelling = tabType === TAB_TYPE_SELLING;
  const trackingLabel = isSelling ? 'tracking_selling' : 'tracking_buying';

  return (
    <S.Tracking data-cy="tracking-info">
      <S.TrackingTitle>
        {i18n(i18nKey(trackingLabel))}
        {' #'}
      </S.TrackingTitle>
      <S.TrackingInfo>
        {transaction.shipment ? (
          <S.TrackingPackageInfo>
            <S.TrackingNumber>
              <S.TrackingLink
                data-testid="tracking-number"
                rel="noopener noreferrer"
                target="_blank"
                href={transaction.shipment.tracking.url}
              >
                {transaction.shipment.tracking.id}
              </S.TrackingLink>
            </S.TrackingNumber>
          </S.TrackingPackageInfo>
        ) : (
          <S.TrackingInfoDesc>{i18n(i18nKey`infosoon`)}</S.TrackingInfoDesc>
        )}
      </S.TrackingInfo>
      {transaction?.shipment && isSelling && !hasLabelless && (
        <S.TrackingLabel>
          <S.TrackingLabelLink
            as="a"
            rel="noopener noreferrer"
            target="_blank"
            data-testid="download-label"
            href={transaction.shipment.labelUrl}
          >
            {i18n(i18nKey`download_label`)}
          </S.TrackingLabelLink>
        </S.TrackingLabel>
      )}
    </S.Tracking>
  );
};

export default memo(TrackingInfo);
